import React, { useEffect } from 'react';
import Communicateb from './Communicateb';


import AerospaceInsightsCards from './AerospaceInsightsCards';
import CommunicationsButtons from './CommunicationsButtons';
import CommunicationPagedata from './CommunicationPagedata';
import CommunicationPaegeSecondtabs from './CommunicationPaegeSecondtabs';
import Communicationverticaltabs from './Communicationverticaltabs';
import CommunicationCargot from './CommunicationCargot';
import Itrequestform from './Itrequestform';
import Footer from './Footer';
import Communicationthirdtab from './Communicationthirdtab';
const Communication = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []); // Empty dependency array ensures it only runs once when the component mounts
    // Scroll to the top of the page when the component mounts

    return (
        <div style={{ background: '#fff' }}>
            <Communicateb />
            <CommunicationsButtons />
            <CommunicationPagedata />
            <Communicationverticaltabs />

            <CommunicationPaegeSecondtabs />
            <Communicationthirdtab />
            {/* <Crigotpage /> */}
            <CommunicationCargot />


            <AerospaceInsightsCards />
            <br></br>
            <Itrequestform />
            <div style={{ marginTop: "-60px" }}>
                <Footer />
            </div>



            <style>
                {`
           h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          }
          `}
            </style>
        </div>
    )
}

export default Communication;